import termsApi from '../../../services/plataforma/term';

export default {
  getAll({ commit }) {
    return new Promise((resolve, reject) => {
      termsApi.getAll()
        .then(response => {
          commit('SET_TERMS', response.data.terms);
          resolve();
        })
        .catch(e => {
          reject(e.response.data.error);
        });
    });
  },
  create({ commit }, term) {
    return new Promise((resolve, reject) => {
      termsApi.create(term)
        .then(response => {
          commit('SET_NEW_CUSTOM_TERM', {
            termId   : response.data.term_id,
            id       : response.data.id,
            language : response.data.language_id,
            name     : response.data.name
          });
          resolve(response.data);
        })
        .catch(e => {
          reject(e.response.data.error);
        });
    });
  },
  async update({ commit }, { termId, customTermId, name }) {
    return new Promise((resolve, reject) => {
      termsApi.update({ customTermId, name })
        .then(() => {
          commit('SET_NEW_VALUE', { termId, customTermId, name });
          resolve();
        })
        .catch(e => {
          reject(e.response.data.error);
        });
    });
  }
};
